import type { ReactNode } from "react";
import styles from "./PageToolbar.module.scss";

/** A list-page toolbar: a search slot on the left and optional actions right. */
export function PageToolbar({ children, actions }: { children?: ReactNode; actions?: ReactNode }) {
  return (
    <div className={styles.toolbar}>
      {children != null && <div className={styles.search}>{children}</div>}
      {actions != null && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
